import { useState, useEffect, useCallback } from 'react';
import { Pane, Heading, SelectField, Spinner } from 'evergreen-ui';
import { getLoginHistory } from '../services/loginHistoryService';
import LoginHistoryTable from './LoginHistoryTable';

const LoginHistory = ({ collaborators }) => {
    const [entries, setEntries] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState('');
    const [loading, setLoading] = useState(true);

    const fetchHistory = useCallback(async () => {
        setLoading(true);
        try {
            const data = await getLoginHistory({ userId: selectedUserId || undefined });
            setEntries(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [selectedUserId]);

    useEffect(() => { fetchHistory(); }, [fetchHistory]);

    return (
        <Pane elevation={1} padding={16} marginTop={24} background="tint1" borderRadius={4}>
            <Heading size={500} marginBottom={12}>Storico accessi</Heading>
            <SelectField
                label="Filtra per collaboratore"
                value={selectedUserId}
                onChange={e => setSelectedUserId(e.target.value)}
                marginBottom={12}
                maxWidth={300}
            >
                <option value="">Tutti</option>
                {collaborators.map(c => (
                    <option key={c.id} value={c.id}>{c.nome} {c.cognome}</option>
                ))}
            </SelectField>
            {loading ? <Spinner size={24} /> : <LoginHistoryTable entries={entries} />}
        </Pane>
    );
};

export default LoginHistory;
